import { useMemo } from "react"
import { GetApp } from "../../App"
import { classNames } from "../../Components"
import { TimelineFade } from "../../Components/TimelineFade"
import { ICruise } from "../../Types"
import { CruiseCalendarGridViewProps } from "./Params"

export function CruiseCalendarGridView({ sortedCruises, minMaxYears, selectCruise, onFocus }: CruiseCalendarGridViewProps) {
  const app = GetApp()!;
  const t = app.getT("CruiseCalendarView");

  const years = useMemo(() => {
    const now = new Date().valueOf();
    const years = [];
    let n = 0;
    let cruise: ICruise | undefined = sortedCruises[n];
    for (let y = minMaxYears[0]; y <= minMaxYears[1]; y++) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
      const months: any[] = [];
      for (let m = 0; m < 12; m++) {
        const monthStart = new Date(Date.UTC(y, m, 1)).valueOf();
        const monthEnd = new Date(Date.UTC(y, m + 1, 1)).valueOf();
        const cruises = [];
        let completed = false;
        while (!completed && cruise) {
          cruise = ((cruise: ICruise) => {
            completed = true;
            const s = (cruise.startedAt ? new Date(Date.parse(cruise.startedAt)) : new Date()).valueOf();
            if (s >= monthStart && s < monthEnd) {
              if (s - monthStart >= 60 * 60 * 24) {
                cruises.push(<div key={`spacer-start-${cruise.id}`} className="CruiseCalendarView-cruise-spacer"></div>);
              }
              cruises.push(
                <div className={classNames(["CruiseCalendarView-cruise", !cruise.completedAt && "active"])} data-cruise-id={cruise.id} onClick={() => selectCruise(cruise.id)} key={cruise.id}>
                  <div className="CruiseCalendarView-cruise-title">
                    <span>{cruise.title || t("untitled_cruise")} ({cruise.startedAt && app.format("date", cruise.startedAt)} - {cruise.completedAt ? app.format("date", cruise.completedAt) : ""})</span>
                    {!cruise.completedAt && !app.cloudSession() && (
                      <button className="button focus" onClick={(e) => {
                        e.stopPropagation();
                        onFocus();
                      }}
                      >{t("focus")}</button>
                    )}
                  </div>
                </div>,
              );
            } else if (s < monthEnd && (cruise.completedAt || monthStart < now)) {
              cruises.push(<div className={classNames(["CruiseCalendarView-cruise", !cruise.completedAt && "active"])} data-cruise-id={cruise.id} onClick={() => selectCruise(cruise.id)} key={cruise.id}></div>);
            }
            if (cruise.completedAt) {
              const e = new Date(Date.parse(cruise.completedAt)).valueOf();
              if (e <= monthEnd - 60 * 60 * 24) {
                cruises.push(<div key={`spacer-end-${cruise.id}`} className="CruiseCalendarView-cruise-spacer"></div>);
              }
              if (e >= monthStart && e <= monthEnd) {
                n++;
                completed = false;
                return sortedCruises[n];
              }
            }
            return cruise;
          })(cruise);
        }
        months.push(
          <div key={m} className={classNames(["CruiseCalendarView-month", `month-${m + 1}`])}>
            <div className="marker"></div>
            {cruises}
          </div>,
        );
      }
      years.push(
        <div key={y} className={`CruiseCalendarView-year year-${y}`}>
          <div className="CruiseCalendarView-year-number-container">
            <div className="CruiseCalendarView-year-number">{y}</div>
          </div>
          <div className="CruiseCalendarView-months-container">
            <div className="year-marker"></div>
            {months}
            <div className="year-marker"></div>
          </div>
        </div>,
      );
    }
    return years;
  }, [sortedCruises, minMaxYears]);

  return (
    <div className="CruiseCalendarView">
      <TimelineFade before={true} width={20} />
      {years}
      <TimelineFade before={false} width={20} />
    </div>
  );
}
